// extracted by mini-css-extract-plugin
export default {"section":"Patch_section__Ck9Hj","patchNews":"Patch_patchNews__fHpP+","title":"Patch_title__oXhYB","sub":"Patch_sub__rimnH","image":"Patch_image__6PdMT"};